import {
  Box,
  createStyles,
  fade,
  IconButton,
  Link,
  makeStyles,
  Menu,
  MenuItem,
  Theme,
  Tooltip,
  Typography
} from '@material-ui/core';
import React from 'react';
import { AccountCircle } from '@material-ui/icons';
import { IUser } from './user';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItem: {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      fontWeight: 400,
      color: theme.palette.primary.light,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    inputRoot: {
      color: 'inherit'
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '12ch',
        '&:focus': {
          width: '12ch'
        }
      }
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      color: 'black',
      backgroundColor: fade(theme.palette.common.white, 0.85),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.95)
      },
      overflow: 'visible',
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto'
      }
    }
  })
);
interface IHeaderProps {
  readonly user?: IUser;
  readonly headerLogoUrl?: string;
  readonly onClickLogin?: () => void;
}

const Header: React.FunctionComponent<IHeaderProps> = ({
  user,
  onClickLogin,
  headerLogoUrl
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = anchorEl !== null;
  const classes = useStyles();
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box
      height={{ xs: '10vh', sm: '8vh', md: '6vh', lg: '7vh', xl: '8vh' }}
      marginBottom={{ sm: '8vh', xs: '10vh' }}
      bgcolor="rgba(240,240,240,0.7)"
      display="flex"
      width="inherit"
      alignItems="center"
      justifyContent="flex-start"
      position="absolute"
      right={0}
      left={0}
    >
      <Box ml={2} />
      <Box flex={1} />
      <Box>
        {user ? (
          <div>
            <Tooltip title="User">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
              >
                <Box my={-2} clone>
                  <AccountCircle htmlColor="white" />
                </Box>
              </IconButton>
            </Tooltip>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              open={open}
              onClose={handleClose}
              elevation={1}
            >
              <MenuItem>
                <Typography variant="subtitle1">
                  {`${user.lastName}, ${user.firstName}`}
                </Typography>
              </MenuItem>
              <MenuItem>
                <Link
                  color="textPrimary"
                  onClick={() => {
                    window.sessionStorage.clear();
                    window.location.reload();
                  }}
                  variant="subtitle1"
                >
                  Logout
                </Link>
              </MenuItem>
            </Menu>
          </div>
        ) : (
          <Link className={classes.menuItem} onClick={onClickLogin} href="#">
            LOGIN
          </Link>
        )}
      </Box>
    </Box>
  );
};

export default Header;
